import { render, staticRenderFns } from "./basarili.vue?vue&type=template&id=3e017fb0"
import script from "./basarili.vue?vue&type=script&lang=js"
export * from "./basarili.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports